var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKid2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.6 105.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #393939;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6847",
    "data-name": "Group 6847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8953",
    "data-name": "Path 8953",
    className: "cls-1",
    d: "M52.8,23.55c5.14,0,9.3,4.16,9.3,9.3s-4.16,9.3-9.3,9.3-9.3-4.16-9.3-9.3c0-5.13,4.17-9.29,9.3-9.3M52.8,18.07c-8.17,0-14.79,6.62-14.79,14.79s6.62,14.79,14.79,14.79c8.17,0,14.79-6.62,14.79-14.79h0c0-8.17-6.62-14.79-14.79-14.79h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8954",
    "data-name": "Path 8954",
    className: "cls-1",
    d: "M52.8,105.6C23.64,105.6,0,81.96,0,52.8S23.64,0,52.8,0s52.8,23.64,52.8,52.8c-.03,29.15-23.65,52.77-52.8,52.8M52.8,5.48c-26.13,0-47.31,21.18-47.31,47.32,0,26.13,21.18,47.31,47.32,47.31,26.13,0,47.31-21.18,47.31-47.31-.03-26.12-21.2-47.28-47.32-47.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8955",
    "data-name": "Path 8955",
    className: "cls-1",
    d: "M78.41,79.65c-1.52,0-2.74-1.23-2.74-2.74h0v-9.77c0-6.06-4.92-10.97-10.98-10.98h-23.76c-6.06,0-10.97,4.92-10.98,10.98v9.77c-.03,1.52-1.28,2.72-2.8,2.69-1.47-.03-2.66-1.22-2.69-2.69v-9.77c0-9.09,7.38-16.46,16.47-16.47h23.76c9.09,0,16.46,7.38,16.47,16.47v9.77c0,1.52-1.23,2.74-2.74,2.74h0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKid2);
export default __webpack_public_path__ + "static/media/kid-2.3fb1720f2b22838edd605a38452bcf64.svg";
export { ForwardRef as ReactComponent };